export default __webpack_public_path__ + "static/media/apple-tv-rc.b9464a25.png";